import { jsx as _jsx } from "react/jsx-runtime";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/date-input.css";
import { forwardRef, useCallback } from "react";
import ReactDatePicker from "react-datepicker";
import { DateInputField } from "./DateInputField";
import { DateInputHeader } from "./DateInputHeader";
export const DateInput = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { showCalendarIcon = true, onChange, name, size, showClearButton = true, style, className, placeholder, ...props } = param;
    const onDateChange = useCallback((date)=>{
        onChange(date);
    }, [
        onChange
    ]);
    const onClear = useCallback((e)=>{
        e.stopPropagation();
        onDateChange(null, e);
    }, [
        onDateChange
    ]);
    const renderCustomHeader = useCallback((params)=>/*#__PURE__*/ _jsx(DateInputHeader, {
            ...params
        }), []);
    const { testId, ...restProps } = props;
    return /*#__PURE__*/ _jsx(ReactDatePicker, {
        showPopperArrow: false,
        onChange: onDateChange,
        customInput: /*#__PURE__*/ _jsx(DateInputField, {
            showCalendarIcon: showCalendarIcon,
            name: name,
            ref: ref,
            size: size,
            className: className,
            style: style,
            placeholder: placeholder,
            onClear: showClearButton ? onClear : undefined,
            "data-testid": testId
        }),
        renderCustomHeader: renderCustomHeader,
        ...restProps
    });
});
DateInput.displayName = "DateInput";
